import React from "react";
import Title from "./components/Title";


function About(){
    return (
        <>
        <Title name="Unleash Healthcare Potential"/>
    </>
    );
}

export default About;